import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ProductionQuantityLimitsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"production_quantity_limits"}/>
}
